var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectTrendingDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5001 5C15.5001 4.54 15.1276 4.16667 14.6668 4.16667C14.206 4.16667 13.8335 4.54 13.8335 5V6.91417L10.2993 2.79083C10.036 2.4825 9.58764 2.40916 9.23764 2.61916L5.68347 4.75167L1.97431 0.299998C1.67931 -0.052502 1.15514 -0.102502 0.799308 0.193331C0.446808 0.487498 0.398475 1.01333 0.692641 1.36666L4.85931 6.36666C5.12347 6.6825 5.57764 6.76 5.92931 6.5475L9.49181 4.41L12.8551 8.33333H10.5001C10.0393 8.33333 9.66681 8.70667 9.66681 9.16667C9.66681 9.62667 10.0393 10 10.5001 10H14.6668C14.7701 10 14.8726 9.9775 14.9701 9.93833C15.011 9.9225 15.0426 9.89583 15.0801 9.875C15.1235 9.84916 15.1701 9.83333 15.2085 9.79917C15.2168 9.7925 15.2201 9.7825 15.2276 9.775C15.2735 9.73333 15.3051 9.6825 15.3401 9.63167C15.3676 9.59167 15.4001 9.55667 15.4193 9.51333C15.4401 9.46916 15.4468 9.42 15.4585 9.3725C15.4743 9.31417 15.4918 9.2575 15.4935 9.1975C15.4943 9.18667 15.5001 9.1775 15.5001 9.16667V5Z",
    fill: "#DA515E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectTrendingDown);
export default __webpack_public_path__ + "static/media/ProjectTrendingDown.6568875de291c5a1393029f5650854b1.svg";
export { ForwardRef as ReactComponent };